import LxcError from "~/core/models/LxcError.class";
import type { SectorCreatePayload } from "~/modules/sector/models/SectorCreatePayload.interface";
import type { SectorCreateUpdateResponse } from "~/modules/sector/models/SectorCreateUpdateResponse.type";
import sectorsService from "~/modules/sector/services/sectors.service";

export function useCreateSector(organizationCode?: number) {
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();
  const result: Ref<SectorCreateUpdateResponse | undefined> = ref();

  async function createSector(
    sectorCreatePayload: SectorCreatePayload,
  ): Promise<void> {
    isLoading.value = true;

    error.value = undefined;
    result.value = undefined;

    if (organizationCode) {
      const response = await sectorsService.createSector(
        organizationCode,
        sectorCreatePayload,
      );

      if (LxcError.check(response)) {
        error.value = response;
      } else {
        result.value = response;
      }
    } else {
      throw new Error("Organization code is undefined");
    }

    isLoading.value = false;
  }

  return {
    createSector,
    isLoading,
    error,
    result,
  };
}
